export type DiscoveryAssetStatsCounters = {
  endpointsNew: number;
  webpagesNew: number;
};

export function shouldInvalidateAssetsOnStatsUpdate({
  prev,
  next,
}: {
  prev: DiscoveryAssetStatsCounters | undefined;
  next: DiscoveryAssetStatsCounters;
}): boolean {
  if (prev === undefined) {
    return next.endpointsNew > 0 || next.webpagesNew > 0;
  }

  return (
    next.endpointsNew > prev.endpointsNew ||
    next.webpagesNew > prev.webpagesNew
  );
}
